import { render, staticRenderFns } from "./Depreciacion.vue?vue&type=template&id=496305fe&"
import script from "./Depreciacion.vue?vue&type=script&lang=js&"
export * from "./Depreciacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports